import { _get } from "./Axios";

export default class LaporanPersonalApi {
  static getList(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/list?" + params);
  }

  static getDetailPenilaianKinerja(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/realisasi-kinerja?" + params);
  }

  static getDetailPenugasanKhusus(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/penugasan-khusus?" + params);
  }

  static getDetailPengurangan(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/pengurangan?" + params);
  }

  static getDetailKompetensi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/kompetensi?" + params);
  }

  static getDetailPenilaianAkhir(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/penilaian-akhir?" + params);
  }

  static getDetailExportPdf(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/export?" + params, { responseType: 'blob' }, true);
  }
}
